import { useEffect } from 'react';
import { setGtagUserId } from '@/analytics';

export const useAnalytics = (isAuthenticated: boolean, email: string | undefined) => {
  useEffect(() => {
    if (isAuthenticated && email) {
      setGtagUserId(email);
    } else {
      setGtagUserId(null);
    }
  }, [isAuthenticated, email]);
};
